const stepSequence = [
  "lensType",
  "lensTypeVariant",
  "prescription",
  "prescriptionForm",
  "prescriptionUpload",
  "prescriptionValidation",
  "lensPackage",
  "lensAddOn",
  "lensAddOnVariant",
  "review"
];
export {
  stepSequence
};
//# sourceMappingURL=index.js.map
